

import React, { Component, useState, useEffect, useContext } from "react";

import {
  Card, CardImg, CardText, CardBody,
  CardTitle, CardSubtitle, Button
} from 'reactstrap';


import { Link } from 'react-router-dom'

function Assignment_Card(props) {

  const [presentquestion, set_presentquestion] = useState({ answers: (4)['Italy', 'Russia', 'USA', 'Germany'], attempts: 0, category: "Sports", correctanswer: "Russia", failures: 0, id: 0, level: 3, question: "Which country hosted 2014 Winter Olympics?", specificcategory: "Olympics", subcategory: "Sports" });


  ////console.log(props.event)

  function setpoints() {
    ////console.log("calling")
  }



  let { id, name, eventname, levels, specificcategory, limits, category, remainingattempts, totalquestions, eventdisplay, description } = props.event;
  return (
    <div>
      <Card>
        <div className='col-md-4'>
          <CardImg src={"../assets/" + category + ".png"} alt={description} />
        </div>
        <CardBody>
          <CardTitle>{name}</CardTitle>
          <CardTitle>{category}</CardTitle>
          <CardText> Questions: {limits} </CardText>



          {/* 
             { <Link to = {'/quiz?specificcategory='+ specificcategory +'&level=' + levels +"&limits="+limits + "&totalquestions="+totalquestions + "&eventdisplay="+eventdisplay}>


            <Button color="danger"  onClick={() => setpoints()} >Start Quiz</Button> 
            </Link> } */}

          {<Link to={{ pathname: "/quiz", state: props.event }}><Button color="danger">Start Quiz</Button></Link>}

          {/* {<Link to={{ pathname: "/quiz1",  state: presentquestion }}><Button color="danger"> Select Events</Button></Link>} */}


          {/* <Button color="danger" onClick={() => gotoQuestions(specificcategory,level,limits)} >Start Quiz</Button> */}
        </CardBody>
      </Card>
    </div>
  )

}

export default Assignment_Card;
